<div id="container">
  <div class="map" [class.loading]="loading" id="map-{{id}}" inViewport
    (inViewportAction)="inview($event)"></div>
  <div id="loading" *ngIf="loading" @fadeOut>
    <sesio-loader></sesio-loader>
  </div>
</div>
